var render = function render(){var _vm=this,_c=_vm._self._c;return _c('report-line-text',{attrs:{"text":_vm.text}})
}
var staticRenderFns = []

export { render, staticRenderFns }